const styles = {
  pointer: {
    cursor: "pointer",
    "&:hover": {
      "& path:nth-child(2)": {
        fill: "#051D39",
      },
    },
  },
};

export default styles;
